module.exports = __webpack_public_path__ + "img/features_scoretracker_phone_mobile1.4757fb68.jpg";